import { a as languages } from "../../core-8vQkh0Rd.js";
import { t as addJsxTag } from "../../jsx-shared-DIcqKxFi.js";
import "./javascript.js";
//#region src/prism/languages/jsx.js
addJsxTag(languages.js, "jsx");
//#endregion

//# sourceMappingURL=jsx.js.map